const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export function resolvePartnerImg(value) {
  if (!value) return null;
  if (value.startsWith("http")) return value;
  return `${BACKEND_URL}/uploads/partner-registrations/${value}`;
}
